/**
 * Brace1 Garage Tuning UI — mockup shell helpers.
 * Does not replace garage.js. Adds layout interactions + category/slot filtering.
 */
(function () {
  var root = document.querySelector(".brace1-garage--tuning[data-brace1-garage]");
  if (!root) return;

  var SLOT_LABELS = {
    strut: "Front Strut",
    coilover: "Coilovers",
    arm: "Control Arms",
    mirrors: "Mirrors",
    shifter: "Shifter",
    paddles: "Paddles",
  };

  /* Honest catalog slot → category grouping for Brace1 inventory */
  var SLOT_CATEGORY = {
    strut: "chassis-bracing",
    coilover: "suspension",
    arm: "suspension",
    mirrors: "exterior",
    shifter: "interior",
    paddles: "interior",
  };

  var CATEGORY_SLOTS = {
    "chassis-bracing": ["strut"],
    exterior: ["mirrors"],
    interior: ["shifter", "paddles"],
    suspension: ["coilover", "arm"],
    brakes: [],
    exhaust: [],
    intake: [],
    engine: [],
    drivetrain: [],
    "wheels-tires": [],
    lighting: [],
    electronics: [],
    maintenance: [],
  };

  var yearSelect = root.querySelector("#yearSelect");
  var makeSelect = root.querySelector("#makeSelect");
  var modelSelect = root.querySelector("#modelSelect");
  var nameEl = root.querySelector("#tuningVehicleName");
  var yearEl = root.querySelector("#tuningVehicleYear");
  var metaEl = root.querySelector("#tuningVehicleMeta");
  var infoYear = root.querySelector("#tuningInfoYear");
  var infoMake = root.querySelector("#tuningInfoMake");
  var infoModel = root.querySelector("#tuningInfoModel");
  var imageEl = root.querySelector("#tuningVehicleImage");
  var categoryEmpty = root.querySelector("#tuningCategoryEmpty");
  var categoryBrowse = root.querySelector("#tuningCategoryBrowse");
  var categoryRail = root.querySelector("#tuningCategoryRail");
  var partsList = root.querySelector("#partsList");
  var buildTotal = root.querySelector("#buildTotal");
  var buildTotalDisplay = root.querySelector("#tuningBuildTotalDisplay");
  var viewBuildBtn = root.querySelector("#tuningViewBuild");

  var vehicleImages = [];
  try {
    var raw = root.querySelector("#tuningVehicleImages");
    if (raw) vehicleImages = JSON.parse(raw.textContent || "[]") || [];
  } catch (err) {
    vehicleImages = [];
  }

  var state = {
    activeCategoryId: "all",
    activeCategoryName: "All parts",
    activeSlots: [],
    activeCollectionUrl: "",
    isAllParts: true,
  };

  function val(select) {
    return select && select.value ? String(select.value).trim() : "";
  }

  function normalize(str) {
    return String(str || "")
      .trim()
      .toLowerCase();
  }

  function syncVehicleLabels() {
    var year = val(yearSelect);
    var make = val(makeSelect);
    var model = val(modelSelect);
    var trimSelect = root.querySelector("#trimSelect");
    var engineSelect = root.querySelector("#engineSelect");
    var trim = val(trimSelect);
    var engine = val(engineSelect);
    var ready = Boolean(year && make && model);

    if (yearEl) yearEl.textContent = year || "";
    if (nameEl) {
      nameEl.textContent = ready ? make + " " + model : "Select a vehicle";
    }
    var hpEl = root.querySelector("#tuningVehicleHp");
    if (hpEl) {
      var hp =
        ready && typeof window.BRACE1_formatVehicleHp === "function"
          ? window.BRACE1_formatVehicleHp(year, make, model, trim, engine)
          : "";
      hpEl.textContent = hp || "";
      hpEl.hidden = !hp;
    }
    if (metaEl) {
      metaEl.textContent = ready ? "Selected vehicle" : "Select year, make, and model";
    }
    if (infoYear) infoYear.textContent = year || "—";
    if (infoMake) infoMake.textContent = make || "—";
    if (infoModel) infoModel.textContent = model || "—";

    var infoTrim = root.querySelector("#tuningInfoTrim");
    var infoEngine = root.querySelector("#tuningInfoEngine");
    if (infoTrim) infoTrim.textContent = trim || "—";
    if (infoEngine) infoEngine.textContent = engine || "—";
    /* Trim/engine chips stay visible — they are the inline selects */

    if (categoryBrowse && ready) {
      categoryBrowse.textContent = "View all →";
    }

    updateVehicleImage(year, make, model);
    applyPartVisibility();
  }

  function updateVehicleImage(year, make, model) {
    if (!imageEl) return;
    if (!make || !model) {
      imageEl.hidden = true;
      imageEl.removeAttribute("src");
      imageEl.alt = "";
      root.classList.remove("has-vehicle-image");
      return;
    }

    var y = Number(year) || 0;
    var makeKey = normalize(make);
    var modelKey = normalize(model);
    var yearMatch = null;
    var modelMatch = null;

    vehicleImages.forEach(function (row) {
      if (normalize(row.make) !== makeKey || normalize(row.model) !== modelKey) return;
      var start = Number(row.yearStart) || 0;
      var end = Number(row.yearEnd) || 0;
      if (y && start && end && y >= start && y <= end) yearMatch = row;
      else if (!start && !end) modelMatch = row;
      else if (y && start && !end && y >= start) yearMatch = yearMatch || row;
      else if (y && end && !start && y <= end) yearMatch = yearMatch || row;
      else if (!y) modelMatch = modelMatch || row;
    });

    var chosen = yearMatch || modelMatch;
    if (chosen && chosen.image) {
      imageEl.src = chosen.image;
      imageEl.alt = chosen.alt || make + " " + model;
      imageEl.hidden = false;
      root.classList.add("has-vehicle-image");
    } else {
      imageEl.hidden = true;
      imageEl.removeAttribute("src");
      imageEl.alt = "";
      root.classList.remove("has-vehicle-image");
    }
  }


  function sortCategories() {
    if (!categoryRail) return;
    var buttons = Array.prototype.slice.call(
      categoryRail.querySelectorAll("[data-tuning-category]")
    );
    buttons
      .sort(function (a, b) {
        return (
          (Number(a.dataset.displayOrder) || 0) - (Number(b.dataset.displayOrder) || 0)
        );
      })
      .forEach(function (btn) {
        categoryRail.appendChild(btn);
      });
  }

  var PRICE_BUCKETS = [
    { id: "0-100", label: "Under $100", min: 0, max: 100 },
    { id: "100-150", label: "$100 – $150", min: 100, max: 150 },
    { id: "150-200", label: "$150 – $200", min: 150, max: 200 },
    { id: "200-plus", label: "$200+", min: 200, max: Infinity },
  ];

  var brandsEl = root.querySelector("#tuningFilterBrands");
  var pricesEl = root.querySelector("#tuningFilterPrices");
  var slotsEl = root.querySelector("#tuningFilterSlots");
  var clearBtn = root.querySelector("#gtFiltersClear");
  var clearMobileBtn = root.querySelector("#gtFiltersClearMobile");
  var openBtn = root.querySelector("#gtFiltersOpen");
  var closeBtn = root.querySelector("#gtFiltersClose");
  var applyBtn = root.querySelector("#gtFiltersApply");
  var backdrop = root.querySelector("#gtFiltersBackdrop");
  var filtersPanel = root.querySelector("#gtFiltersPanel");
  var activeCountEl = root.querySelector("#gtFiltersActiveCount");
  var fitToggle = root.querySelector("#tuningFilterFitOnly");
  var suppressUrlWrite = false;
  var rebuildingFilters = false;

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function selectedValues(selector) {
    return Array.prototype.slice
      .call(root.querySelectorAll(selector + ":checked"))
      .map(function (el) {
        return el.value;
      })
      .filter(Boolean);
  }

  function enabledFilterSlots() {
    var selected = selectedValues("[data-filter-slot]");
    if (!selected.length) return null;
    var enabled = {};
    selected.forEach(function (slot) {
      enabled[slot] = true;
    });
    return enabled;
  }

  function partSlotFromCard(card) {
    var fromAttr = card.getAttribute("data-slot");
    if (fromAttr) return String(fromAttr).trim().toLowerCase();

    var meta = card.querySelector(".part__meta");
    var text = meta ? meta.textContent || "" : "";
    var found = "";
    Object.keys(SLOT_LABELS).forEach(function (slot) {
      if (text.indexOf(SLOT_LABELS[slot]) !== -1) found = slot;
    });
    return found;
  }

  function resolveCategorySlots(button) {
    if (!button) return [];
    var id = button.dataset.categoryId || "";
    if (id === "all") return [];

    var mapped = String(button.dataset.catalogSlots || "")
      .split(",")
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
    var nameKey = normalize(button.dataset.categoryName || "").replace(/\s+/g, "-");
    if (mapped.length) {
      if (nameKey === "suspension" && mapped.indexOf("arm") === -1) mapped.push("arm");
      return mapped;
    }

    var iconGuess = nameKey;
    if (CATEGORY_SLOTS.hasOwnProperty(iconGuess)) return CATEGORY_SLOTS[iconGuess].slice();

    if (nameKey.indexOf("chassis") !== -1 || nameKey.indexOf("bracing") !== -1) {
      return CATEGORY_SLOTS["chassis-bracing"].slice();
    }
    if (nameKey.indexOf("exterior") !== -1) return CATEGORY_SLOTS.exterior.slice();
    if (nameKey.indexOf("interior") !== -1) return CATEGORY_SLOTS.interior.slice();
    return [];
  }

  function syncFilterChecksToCategory(slots, isAllParts) {
    var boxes = root.querySelectorAll("[data-filter-slot]");
    if (!boxes.length) return;
    if (isAllParts) {
      boxes.forEach(function (box) {
        box.checked = false;
      });
      updateFilterSummaries();
      return;
    }
    if (!slots.length) {
      boxes.forEach(function (box) {
        box.checked = false;
      });
      updateFilterSummaries();
      return;
    }
    boxes.forEach(function (box) {
      var slot = box.getAttribute("data-filter-slot");
      box.checked = slots.indexOf(slot) !== -1;
    });
    updateFilterSummaries();
  }

  function collectCardFacets() {
    var brands = {};
    var slots = {};
    var prices = [];
    if (!partsList) return { brands: [], slots: [], prices: [] };
    partsList.querySelectorAll(".part").forEach(function (card) {
      var brand = (card.getAttribute("data-brand") || "").trim();
      var slot = partSlotFromCard(card);
      var price = Number(card.getAttribute("data-price") || 0);
      if (brand) brands[brand] = (brands[brand] || 0) + 1;
      if (slot) slots[slot] = (slots[slot] || 0) + 1;
      if (!isNaN(price)) prices.push(price);
    });
    return {
      brands: Object.keys(brands).sort(function (a, b) {
        return a.localeCompare(b);
      }),
      brandCounts: brands,
      slots: Object.keys(slots).sort(),
      slotCounts: slots,
      prices: prices,
    };
  }

  function renderCheckboxList(container, items, attrName, selectedSet) {
    if (!container) return;
    if (!items.length) {
      container.innerHTML = '<p class="gt-filters__empty">No options for current parts.</p>';
      return;
    }
    container.innerHTML = items
      .map(function (item) {
        var value = typeof item === "string" ? item : item.value;
        var label = typeof item === "string" ? item : item.label;
        var count = typeof item === "string" ? 0 : item.count || 0;
        var checked = selectedSet[value] ? " checked" : "";
        return (
          '<label class="gt-filters__check">' +
          '<input type="checkbox" ' +
          attrName +
          '="' +
          escapeHtml(value) +
          '" value="' +
          escapeHtml(value) +
          '"' +
          checked +
          " />" +
          "<span>" +
          escapeHtml(label) +
          (count ? ' <em>(' + count + ")</em>" : "") +
          "</span></label>"
        );
      })
      .join("");
  }

  function rebuildFilterOptions() {
    if (rebuildingFilters) return;
    rebuildingFilters = true;
    var prevBrands = {};
    selectedValues("[data-filter-brand]").forEach(function (v) {
      prevBrands[v] = true;
    });
    var prevPrices = {};
    selectedValues("[data-filter-price]").forEach(function (v) {
      prevPrices[v] = true;
    });
    var prevSlots = {};
    selectedValues("[data-filter-slot]").forEach(function (v) {
      prevSlots[v] = true;
    });

    var facets = collectCardFacets();
    renderCheckboxList(
      brandsEl,
      facets.brands.map(function (brand) {
        return { value: brand, label: brand, count: facets.brandCounts[brand] };
      }),
      "data-filter-brand",
      prevBrands
    );

    var priceItems = PRICE_BUCKETS.filter(function (bucket) {
      return facets.prices.some(function (price) {
        return price >= bucket.min && price < bucket.max;
      });
    }).map(function (bucket) {
      return { value: bucket.id, label: bucket.label };
    });
    renderCheckboxList(pricesEl, priceItems, "data-filter-price", prevPrices);

    renderCheckboxList(
      slotsEl,
      facets.slots.map(function (slot) {
        return {
          value: slot,
          label: SLOT_LABELS[slot] || slot,
          count: facets.slotCounts[slot],
        };
      }),
      "data-filter-slot",
      prevSlots
    );

    bindFilterInputs();
    rebuildingFilters = false;
    applyPartVisibility();
  }

  function priceMatches(price, selectedIds) {
    if (!selectedIds.length) return true;
    return selectedIds.some(function (id) {
      var bucket = PRICE_BUCKETS.filter(function (b) {
        return b.id === id;
      })[0];
      if (!bucket) return false;
      return price >= bucket.min && price < bucket.max;
    });
  }

  function countActiveFilters() {
    var n =
      selectedValues("[data-filter-brand]").length +
      selectedValues("[data-filter-price]").length +
      selectedValues("[data-filter-slot]").length +
      selectedValues("[data-filter-availability]").length;
    return n;
  }

  function updateFilterSummaries() {
    root.querySelectorAll(".gt-filters__group").forEach(function (group) {
      var key = group.getAttribute("data-filter-group");
      var selectedEl = group.querySelector("[data-filter-selected]");
      if (!selectedEl) return;
      var values = [];
      if (key === "brand") values = selectedValues("[data-filter-brand]");
      if (key === "price") {
        values = selectedValues("[data-filter-price]").map(function (id) {
          var bucket = PRICE_BUCKETS.filter(function (b) {
            return b.id === id;
          })[0];
          return bucket ? bucket.label : id;
        });
      }
      if (key === "type") {
        values = selectedValues("[data-filter-slot]").map(function (slot) {
          return SLOT_LABELS[slot] || slot;
        });
      }
      if (key === "availability") {
        values = selectedValues("[data-filter-availability]").map(function (v) {
          return v === "in" ? "In stock" : "Out of stock";
        });
      }
      selectedEl.textContent = values.length ? values.join(", ") : "";
      group.classList.toggle("has-selection", values.length > 0);
    });

    var active = countActiveFilters();
    if (clearBtn) clearBtn.hidden = active === 0;
    if (activeCountEl) {
      if (active > 0) {
        activeCountEl.hidden = false;
        activeCountEl.textContent = String(active);
      } else {
        activeCountEl.hidden = true;
      }
    }
  }

  function writeFilterParams() {
    if (suppressUrlWrite || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      function setOrDelete(key, values) {
        if (values && values.length) url.searchParams.set(key, values.join(","));
        else url.searchParams.delete(key);
      }
      setOrDelete("gf_brand", selectedValues("[data-filter-brand]"));
      setOrDelete("gf_price", selectedValues("[data-filter-price]"));
      setOrDelete("gf_type", selectedValues("[data-filter-slot]"));
      setOrDelete("gf_avail", selectedValues("[data-filter-availability]"));
      if (fitToggle) {
        if (fitToggle.checked) url.searchParams.delete("gf_fit");
        else url.searchParams.set("gf_fit", "0");
      }
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (err) {
      /* ignore */
    }
  }

  function readFilterParams() {
    try {
      var url = new URL(window.location.href);
      suppressUrlWrite = true;
      function applyList(param, selector) {
        var raw = url.searchParams.get(param);
        if (!raw) return;
        var wanted = {};
        raw.split(",").forEach(function (v) {
          wanted[decodeURIComponent(v.trim())] = true;
        });
        root.querySelectorAll(selector).forEach(function (el) {
          el.checked = Boolean(wanted[el.value]);
        });
      }
      applyList("gf_brand", "[data-filter-brand]");
      applyList("gf_price", "[data-filter-price]");
      applyList("gf_type", "[data-filter-slot]");
      applyList("gf_avail", "[data-filter-availability]");
      if (fitToggle && url.searchParams.get("gf_fit") === "0") {
        fitToggle.checked = false;
        fitToggle.setAttribute("aria-checked", "false");
      }
      suppressUrlWrite = false;
    } catch (err) {
      suppressUrlWrite = false;
    }
  }

  function clearFilters() {
    root
      .querySelectorAll(
        "[data-filter-brand], [data-filter-price], [data-filter-slot], [data-filter-availability]"
      )
      .forEach(function (el) {
        el.checked = false;
      });
    applyPartVisibility();
    writeFilterParams();
  }

  function applyPartVisibility() {
    if (!partsList) return;
    var cards = partsList.querySelectorAll(".part");
    var categorySlots = state.activeSlots;
    var filterSlots = enabledFilterSlots();
    var brands = selectedValues("[data-filter-brand]");
    var prices = selectedValues("[data-filter-price]");
    var availability = selectedValues("[data-filter-availability]");
    var visibleCount = 0;
    var categoryName = state.activeCategoryName || "this category";
    var vehicleReady = Boolean(val(yearSelect) && val(makeSelect) && val(modelSelect));
    var isAllParts = Boolean(state.isAllParts);

    cards.forEach(function (card) {
      var slot = partSlotFromCard(card);
      var brand = card.getAttribute("data-brand") || "";
      var price = Number(card.getAttribute("data-price") || 0);
      var available = card.getAttribute("data-available") !== "false";
      var hide = false;

      if (isAllParts) {
        if (filterSlots && slot && !filterSlots[slot]) hide = true;
      } else if (categorySlots.length) {
        if (!slot || categorySlots.indexOf(slot) === -1) hide = true;
      } else {
        hide = true;
      }

      if (!hide && brands.length && brands.indexOf(brand) === -1) hide = true;
      if (!hide && !priceMatches(price, prices)) hide = true;
      if (!hide && availability.length) {
        var ok =
          (availability.indexOf("in") !== -1 && available) ||
          (availability.indexOf("out") !== -1 && !available);
        if (!ok) hide = true;
      }

      card.classList.toggle("is-filter-hidden", hide);
      if (!hide) visibleCount += 1;
    });

    if (categoryEmpty) {
      var showEmpty = !isAllParts && visibleCount === 0 && vehicleReady;
      categoryEmpty.hidden = !showEmpty;
      if (showEmpty) {
        var safeName = String(categoryName)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
        categoryEmpty.innerHTML =
          "No compatible parts currently listed for <strong>" +
          safeName +
          "</strong>." +
          (state.activeCollectionUrl
            ? ' <a class="gt-parts__browse" href="' +
              state.activeCollectionUrl +
              '">Browse all</a>'
            : "");
      }
    }

    var hint = root.querySelector("#panelHint");
    var eyebrow = root.querySelector("#panelEyebrow");
    if (hint) {
      if (isAllParts) {
        if (eyebrow) eyebrow.textContent = "FEATURED PARTS";
        hint.textContent =
          visibleCount +
          " part" +
          (visibleCount === 1 ? "" : "s") +
          " available — click parts to preview. Different categories stack; the same type counts once.";
      } else if (visibleCount) {
        if (eyebrow) eyebrow.textContent = String(categoryName).toUpperCase();
        hint.textContent =
          "Showing " +
          visibleCount +
          " compatible part" +
          (visibleCount === 1 ? "" : "s") +
          " in " +
          categoryName +
          ".";
      } else {
        if (eyebrow) eyebrow.textContent = String(categoryName).toUpperCase();
        hint.textContent = "No Brace1 catalog parts are mapped to " + categoryName + " yet.";
      }
    }

    updateFilterSummaries();
  }

  function bindFilterInputs() {
    root
      .querySelectorAll(
        "[data-filter-brand], [data-filter-price], [data-filter-slot], [data-filter-availability]"
      )
      .forEach(function (el) {
        if (el.dataset.filterBound === "1") return;
        el.dataset.filterBound = "1";
        el.addEventListener("change", function () {
          applyPartVisibility();
          writeFilterParams();
        });
      });
  }

  function openFiltersDrawer() {
    if (!filtersPanel) return;
    filtersPanel.classList.add("is-open");
    root.classList.add("gt-filters-open");
    document.documentElement.classList.add("gt-filters-drawer-open");
    if (backdrop) backdrop.hidden = false;
    if (openBtn) openBtn.setAttribute("aria-expanded", "true");
  }

  function closeFiltersDrawer() {
    if (!filtersPanel) return;
    filtersPanel.classList.remove("is-open");
    root.classList.remove("gt-filters-open");
    document.documentElement.classList.remove("gt-filters-drawer-open");
    if (backdrop) backdrop.hidden = true;
    if (openBtn) openBtn.setAttribute("aria-expanded", "false");
  }

  function setCategory(button) {
    var buttons = root.querySelectorAll("[data-tuning-category]");
    buttons.forEach(function (btn) {
      var active = btn === button;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });

    if (!button) {
      var allBtn = root.querySelector("#tuning-cat-all");
      if (allBtn) {
        allBtn.classList.add("is-active");
        allBtn.setAttribute("aria-selected", "true");
        button = allBtn;
      }
    }

    state.activeCategoryId = button ? button.dataset.categoryId : "all";
    state.activeCategoryName = button ? button.dataset.categoryName || "All parts" : "All parts";
    state.isAllParts = state.activeCategoryId === "all";
    state.activeSlots = state.isAllParts ? [] : resolveCategorySlots(button);
    state.activeCollectionUrl = button ? button.dataset.collectionUrl || "" : "";

    root.dataset.activeCategory = state.activeCategoryId || "";
    root.dataset.activeCategorySlots = state.activeSlots.join(",");
    root.dataset.allParts = state.isAllParts ? "true" : "false";

    if (categoryBrowse) {
      categoryBrowse.href = state.activeCollectionUrl || "/collections/all";
    }

    if (!state.isAllParts) {
      syncFilterChecksToCategory(state.activeSlots, false);
    }
    applyPartVisibility();
    writeFilterParams();

    root.dispatchEvent(
      new CustomEvent("brace1:tuning-category", {
        bubbles: true,
        detail: {
          id: state.activeCategoryId,
          name: state.activeCategoryName,
          slots: state.activeSlots.slice(),
          collectionUrl: state.activeCollectionUrl,
          isAllParts: state.isAllParts,
        },
      })
    );
  }

  function syncBuildTotalDisplay() {
    if (buildTotal && buildTotalDisplay) {
      buildTotalDisplay.textContent = buildTotal.textContent || "$0.00";
    }
  }

  function bindCategoryScroller() {
    if (!categoryRail) return;
    var scroller = root.querySelector("[data-catbar-scroller]");
    var prevBtn = root.querySelector("[data-catbar-prev]");
    var nextBtn = root.querySelector("[data-catbar-next]");
    var fadeLeft = root.querySelector("[data-catbar-fade-left]");
    var fadeRight = root.querySelector("[data-catbar-fade-right]");
    if (!scroller) return;

    function updateCatbarOverflow() {
      var maxScroll = Math.max(0, categoryRail.scrollWidth - categoryRail.clientWidth);
      var left = categoryRail.scrollLeft;
      var canScroll = maxScroll > 2;
      var showLeft = canScroll && left > 2;
      var showRight = canScroll && left < maxScroll - 2;

      if (fadeLeft) fadeLeft.classList.toggle("is-visible", showLeft);
      if (fadeRight) fadeRight.classList.toggle("is-visible", showRight);
      if (prevBtn) prevBtn.hidden = !showLeft;
      if (nextBtn) nextBtn.hidden = !showRight;
      scroller.classList.toggle("has-overflow", canScroll);
    }

    function scrollByPage(direction) {
      var amount = Math.max(160, Math.floor(categoryRail.clientWidth * 0.7));
      categoryRail.scrollBy({ left: direction * amount, behavior: "smooth" });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        scrollByPage(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        scrollByPage(1);
      });
    }

    categoryRail.addEventListener("scroll", updateCatbarOverflow, { passive: true });
    categoryRail.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        scrollByPage(-1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        scrollByPage(1);
      } else if (e.key === "Home") {
        e.preventDefault();
        categoryRail.scrollTo({ left: 0, behavior: "smooth" });
      } else if (e.key === "End") {
        e.preventDefault();
        categoryRail.scrollTo({
          left: categoryRail.scrollWidth,
          behavior: "smooth",
        });
      }
    });

    /* Prefer horizontal scroll when wheel/trackpad is used over the rail */
    categoryRail.addEventListener(
      "wheel",
      function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (categoryRail.scrollWidth <= categoryRail.clientWidth + 2) return;
        e.preventDefault();
        categoryRail.scrollLeft += e.deltaY;
        updateCatbarOverflow();
      },
      { passive: false }
    );

    window.addEventListener("resize", updateCatbarOverflow);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(updateCatbarOverflow);
      ro.observe(categoryRail);
      ro.observe(scroller);
    }

    updateCatbarOverflow();
    requestAnimationFrame(updateCatbarOverflow);
  }

  function catalogSlotSet() {
    var present = {};
    var parts =
      window.BRACE1_GARAGE_API && typeof window.BRACE1_GARAGE_API.catalogParts === "function"
        ? window.BRACE1_GARAGE_API.catalogParts()
        : [];
    (parts || []).forEach(function (part) {
      var slot = String((part && part.slot) || "").toLowerCase();
      if (slot) present[slot] = true;
    });
    return present;
  }

  var LOCK_CLOSED =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="11" width="12" height="9" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M8.5 11V8a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  function paintCategoryLocks() {
    var present = catalogSlotSet();
    var known = Object.keys(present).length > 0;
    if (!known) return;
    root.querySelectorAll("[data-tuning-category]").forEach(function (btn) {
      if ((btn.dataset.categoryId || "") === "all") {
        btn.classList.remove("is-locked", "is-unlocked");
        var existing = btn.querySelector(".gt-cat__lock");
        if (existing) existing.remove();
        return;
      }
      var slots = resolveCategorySlots(btn);
      var unlocked = slots.some(function (slot) {
        return present[slot];
      });
      btn.classList.toggle("is-unlocked", unlocked);
      btn.classList.toggle("is-locked", !unlocked);
      btn.setAttribute("aria-disabled", unlocked ? "false" : "true");
      var lock = btn.querySelector(".gt-cat__lock");
      if (unlocked) {
        if (lock) lock.remove();
      } else {
        if (!lock) {
          lock = document.createElement("span");
          lock.className = "gt-cat__lock";
          btn.insertBefore(lock, btn.firstChild);
        }
        lock.innerHTML = LOCK_CLOSED;
      }
      var body = btn.querySelector(".gt-cat__body") || btn;
      var status = btn.querySelector(".gt-cat__status");
      if (!status) {
        status = document.createElement("span");
        status.className = "gt-cat__status";
        body.appendChild(status);
      }
      var nameKey = String(btn.dataset.categoryName || "").toLowerCase();
      var brandLine = unlocked && nameKey.indexOf("suspension") !== -1
        ? '<span class="gt-cat__status-sub gt-cat__status-sub--brand">BC Racing &amp; More</span>'
        : "";
      status.innerHTML = unlocked
        ? '<span class="gt-cat__status-main">Catalog unlocked</span>' + brandLine
        : '<span class="gt-cat__status-main">Locked</span><span class="gt-cat__status-sub">Catalog coming soon</span>';
    });
  }

  function showLockedToast() {
    var toast = document.getElementById("toast");
    if (!toast) return;
    toast.hidden = false;
    toast.textContent = "Locked — catalog coming soon";
    clearTimeout(showLockedToast._t);
    showLockedToast._t = setTimeout(function () {
      toast.hidden = true;
    }, 1600);
  }

  function bindCategories() {
    sortCategories();
    root.querySelectorAll("[data-tuning-category]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-locked")) {
          showLockedToast();
          return;
        }
        setCategory(btn);
      });
    });
    var allBtn = root.querySelector("#tuning-cat-all");
    if (allBtn) setCategory(allBtn);
    bindCategoryScroller();
  }

  [yearSelect, makeSelect, modelSelect].forEach(function (select) {
    if (!select) return;
    select.addEventListener("change", syncVehicleLabels);
  });
  ["#trimSelect", "#engineSelect"].forEach(function (sel) {
    var el = root.querySelector(sel);
    if (el) el.addEventListener("change", syncVehicleLabels);
  });

  var changeCarBtn = root.querySelector("#tuningChangeVehicle");
  if (changeCarBtn && yearSelect) {
    changeCarBtn.addEventListener("click", function () {
      yearSelect.focus();
      yearSelect.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }

  bindFilterInputs();
  if (clearBtn) clearBtn.addEventListener("click", clearFilters);
  if (clearMobileBtn) clearMobileBtn.addEventListener("click", clearFilters);
  if (openBtn) openBtn.addEventListener("click", openFiltersDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeFiltersDrawer);
  if (backdrop) backdrop.addEventListener("click", closeFiltersDrawer);
  if (applyBtn) {
    applyBtn.addEventListener("click", function () {
      applyPartVisibility();
      writeFilterParams();
      closeFiltersDrawer();
    });
  }
  if (fitToggle) {
    fitToggle.addEventListener("change", function () {
      fitToggle.setAttribute("aria-checked", fitToggle.checked ? "true" : "false");
      writeFilterParams();
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && filtersPanel && filtersPanel.classList.contains("is-open")) {
      closeFiltersDrawer();
    }
  });

  if (viewBuildBtn) {
    viewBuildBtn.addEventListener("click", function () {
      var list = root.querySelector("#buildList");
      if (list) list.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }

  var observer = new MutationObserver(function () {
    syncVehicleLabels();
    syncBuildTotalDisplay();
  });

  [yearSelect, makeSelect, modelSelect].forEach(function (select) {
    if (!select) return;
    observer.observe(select, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["disabled", "value"],
    });
  });
  ["#trimSelect", "#engineSelect"].forEach(function (sel) {
    var el = root.querySelector(sel);
    if (!el) return;
    observer.observe(el, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["disabled", "value"],
    });
  });

  if (partsList) {
    var partsObserver = new MutationObserver(function () {
      rebuildFilterOptions();
    });
    partsObserver.observe(partsList, { childList: true });
  }
  if (buildTotal) {
    observer.observe(buildTotal, { childList: true, characterData: true, subtree: true });
  }

  root.addEventListener("brace1:parts-rendered", function () {
    paintCategoryLocks();
    rebuildFilterOptions();
    readFilterParams();
    applyPartVisibility();
  });

  bindCategories();
  syncVehicleLabels();
  syncBuildTotalDisplay();
  rebuildFilterOptions();
  readFilterParams();
  applyPartVisibility();
})();
